// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import SEO from "components/SEO";

// SEO structured data
import { buildBreadcrumbSchema } from "config/structuredData";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Gallery sections
import PhotoGrid from "pages/Gallery/sections/PhotoGrid";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Gallery() {
  return (
    <>
      <SEO
        title="Photo Gallery"
        description="Browse photos of Stalley Beach House — the 6-bedroom beachfront villa, private pool, bedrooms, local beaches and Costa Rica activities near Jacó."
        path="/gallery"
        imageAlt="Photo gallery of Stalley Beach House, Costa Rica"
        schema={buildBreadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Gallery", path: "/gallery" },
        ])}
      />
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="25vh"
        width="100%"
        variant="gradient"
        bgColor="dark"
        sx={{
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <MKTypography variant="h2" component="h1" color="white" textAlign="center">
            {propertyData.name}
          </MKTypography>
          <MKTypography variant="body1" color="white" textAlign="center" opacity={0.8} mt={1}>
            Photo Gallery
          </MKTypography>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <PhotoGrid />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Gallery;
